import { Card, Page, Tabs } from '@shopify/polaris';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApprovalSummaryStore, useLookupStore } from '../../context/useStore';
import Toasts from '../../shared/components/toasts/toasts';
import { useUrl } from '../../shared/util/hanldesave';
import { DOC_TYPES } from '../../shared/components/approvals/approvalsApi';
import ApproveCard from './components/ApproveCard';
import QueueShell from './components/QueueShell';
import { TabTitle } from '../../shell/helmet.jsx';

// My approval queue: the documents waiting for me, one card at a time.
export default function ApprovalQueuePage() {
  const url = useUrl();
  const navigate = useNavigate();
  const summary = useApprovalSummaryStore((state) => state.summary);
  const refreshSummary = useApprovalSummaryStore((state) => state.refresh);
  const setPurchasetypes = useLookupStore((state) => state.setPurchasetypes);
  const setBusinessunits = useLookupStore((state) => state.setBusinessunits);
  const [tab, setTab] = useState(Math.min(1, Math.max(0, parseInt(url.get('tab') || '0', 10) || 0)));
  const [toast, setToast] = useState(false);
  const [toastError, setToastError] = useState(false);
  const initialId = url.get('id');

  useEffect(() => {
    setPurchasetypes();
    setBusinessunits();
    refreshSummary();
  }, [setPurchasetypes, setBusinessunits, refreshSummary]);

  const tabs = useMemo(
    () => [
      { id: 'approve-invoices', content: `Invoices${summary?.mine?.invoices ? ` (${summary.mine.invoices})` : ''}`, panelID: 'approve-invoices' },
      { id: 'approve-creditnotes', content: `Credit notes${summary?.mine?.creditnotes ? ` (${summary.mine.creditnotes})` : ''}`, panelID: 'approve-creditnotes' }
    ],
    [summary]
  );

  const handleTabChange = useCallback(
    (index) => {
      setTab(index);
      navigate({ pathname: '/approvals', search: `?tab=${index}` }, { replace: true });
    },
    [navigate]
  );

  const docType = DOC_TYPES[tab] || 'invoice';

  return (
    <Page fullWidth>
      <TabTitle title="To approve" />
      <Toasts toast={toast} setToast={setToast} errorToast={toastError} setErrorToast={setToastError} toastContent="Saved" />
      <Card>
        <Tabs tabs={tabs} selected={tab} onSelect={handleTabChange}>
          <div style={{ paddingTop: 12 }}>
            <QueueShell
              key={docType}
              docType={docType}
              source="queue"
              initialId={initialId}
              emptyTitle="All done!"
              emptyText={`No ${docType === 'invoice' ? 'invoices' : 'credit notes'} are waiting for your approval.`}
              onDecided={() => refreshSummary()}
              setToast={setToast}
              setErrorToast={setToastError}
              renderCard={({ key, ...props }) => <ApproveCard key={key} {...props} />}
            />
          </div>
        </Tabs>
      </Card>
    </Page>
  );
}
